import { type User, UserType } from '../types/Membership';

// The first user should be the current user. Defaulted to primary member if no current user.
export const getFirstUser = (users: User[], currentUser?: User) => {
    return users.find(({ id, type }) =>
        currentUser != null
            ? id === currentUser.id
            : type === UserType.PRIMARY_MEMBER,
    );
};

// The second user is the other user in the memberships users array.
export const getSecondUser = (users: User[], firstUser?: User) => {
    return users.find(({ id }) => id !== firstUser?.id);
};
